import {
  Directive,
  forwardRef,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator
} from '@angular/forms';

import { LegacyDateKindModel } from '../controls/legacy-date-control/typings/legacy-date.kind';
import { LegacyDateService }   from '../controls/legacy-date-control/legacy-date.service';

@Directive({
  selector : '[worLegacyDateValidator]',
  providers: [
    {
      multi      : true,
      provide    : NG_VALIDATORS,
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      useExisting: forwardRef(() => LegacyDateValidator)
    }
  ]
})
export class LegacyDateValidator implements OnChanges, Validator {
  private _onChange : () => void = null;

  // The earliest allowed date, as a model value.
  @Input('worLegacyDateValidator') startDate : string;

  @Input() isRequired = false;
  @Input() kind       : LegacyDateKindModel = 'date';
  @Input() shownText  : string = null;

  constructor ( private legacyDateService : LegacyDateService ) {}

  // Deferred, as the parent has already read the form's validity in this check.
  ngOnChanges ( changes : SimpleChanges ) : void {
    if ( this._onChange && Object.values(changes).some(change => !change.firstChange) ) {
      Promise.resolve().then(() => this._onChange());
    }
  }

  registerOnValidatorChange ( onChange : () => void ) : void {
    this._onChange = onChange;
  }

  validate ( control : AbstractControl ) : ValidationErrors | null {
    if ( this.isRequired && this.legacyDateService.isBlank(control.value) ) {
      return { required: true };
    }

    const value = control.value || '';

    // AngularJS checks only what the user types in a month field, so a value the page set shows as valid.
    if ( this.legacyDateService.isMonth(this.kind) && this.shownText !== null && ( value === this.shownText || value.trim() === this.shownText ) ) {
      return null;
    }

    const result = this.legacyDateService.parse(control.value, {
      isFilter   : false,
      kind       : this.kind,
      modelFormat: 'date',
      startDate  : this.startDate
    });

    return result.isValid
      ? null
      : { date: true };
  }
}
